import React, { useEffect, useState, useRef } from "react";
import Mousetrap from "mousetrap";
import personalityQuestions from "../../utils/personalityQuestions.js";
import OtpVerificationPopup from "./VerifyOtp";
import Timer from "./Timer";
import { useDispatch } from "react-redux";
import {
  getAssessmentQuestions,
  getManagersList,
  submitAssessmentAnswers,
  updateTestStatus,
} from "../../Redux/Redux-slices/assessmentSlice.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Loader from "../Loader.jsx";
import { useForm } from "react-hook-form";
import { useNotification } from "../../context/NotificationProvider.jsx";
import { FiLoader } from "react-icons/fi";
import ExamSubmittedPopup from "./ExamSubmittedPopup.jsx";

const AssessmentTest = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [manager, setManager] = useState("");
  const [managerList, setManagerList] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [showTimeWarning, setShowTimeWarning] = useState(false);
  const [testSubmitted, setTestSubmitted] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [assessmentQuestions, setAssessmentQuestions] = useState([]);
  const [exitCount, setExitCount] = useState(0);
  const [isFullscreenExited, setIsFullscreenExited] = useState(false);
  const [isExamSubmitted, setIsExamSubmitted] = useState(false);
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const [showTabSwitchWarning, setShowTabSwitchWarning] = useState(false);
  const [limitExceeded, setLimitExceeded] = useState(false);
  const [fullScreenLimitExceeded, setFullScreenLimitExceeded] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const [refreshCount, setRefreshCount] = useState(0);
  const [refreshLimitExceeded, setRefreshLimitExceeded] = useState(false);
  const [showRefreshWarning, setShowRefreshWarning] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const [devToolsCheckInterval, setDevToolsCheckInterval] = useState(null);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [startExam, setStartExam] = useState(false);
  const [showAlreadySubmittedPopup, setShowAlreadySubmittedPopup] = useState(false)

  const { showNotification } = useNotification();

  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const questionRefs = useRef([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    trigger,
  } = useForm({
    defaultValues: {
      manager: "",
    },
  });

  const assessmentId = searchParams.get("assessment");
  const companyId = searchParams.get("company_id");
  const candidateId = searchParams.get("candidate");
  const newJoiner = searchParams.get("is_new_joiner");
  const isStudent = searchParams.get("is_student")
  let studentFirstName = ""
  let studentLastName = ""

  useEffect(() => {
    if (isStudent == "True") {
      studentFirstName = searchParams.get("first_name")
      studentLastName = searchParams.get("last_name")
      setValue("firstName", studentFirstName)
      setValue("lastName", studentLastName)
    }
  }, [isStudent])


  // useEffect(() => {
  //   // Check if mobile device
  //   const checkMobile = () => {
  //     const isMobile =
  //       /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //         navigator.userAgent
  //       );
  //     const isSmallScreen = window.innerWidth < 768; // Tailwind's md breakpoint

  //     setIsMobileDevice(isMobile || isSmallScreen);
  //   };

  //   checkMobile();
  //   window.addEventListener("resize", checkMobile);

  //   return () => {
  //     window.removeEventListener("resize", checkMobile);
  //   };
  // }, []);

  const getQuestions = async () => {
    setLoading(true);
    try {
      let enteredOtp = localStorage.getItem("verifiedOtp");
      const payload = {
        // subject_name: "Personality Assessment 25",
        candidate_id: candidateId,
        // otp: enteredOtp,
      };
      let response = await dispatch(getAssessmentQuestions(payload)).unwrap();
      if (response.success) {
        setAssessmentQuestions(response.questions);
        // Initialize refs for each question
        questionRefs.current = response.questions.map(
          (_, i) => questionRefs.current[i] ?? React.createRef()
        );
      }
      else if (!response.success) {
        setShowAlreadySubmittedPopup(true)
        setTimeout(() => {
          navigate("/")
        }, 3000)
      }
      setLoading(false);
    } catch (error) {
      console.log("err", error);
      setLoading(false);
    }
  };

  const getManagers = async () => {
    try {
      const payload = {
        company_id: companyId,
      };
      let response = await dispatch(getManagersList(payload)).unwrap();
      if (response.success) {
        setManagerList(response.managers);
      }
      setLoading(false);
    } catch (error) {
      console.log("err", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // getQuestions();
    getManagers();
    getQuestions();

    let otpVerified = sessionStorage.getItem("otpVerified", "true");
    if (otpVerified) {
      getQuestions();
    }
  }, []);

  useEffect(() => {
    const verified = sessionStorage.getItem("otpVerified");
    setOtpVerified(verified === "true");
  }, []);

  const handleAnswerChange = (e, questionIndex, option, question_id) => {
    e.preventDefault();
    setAnswers((prevAnswers) => {
      const safeAnswers = Array.isArray(prevAnswers) ? prevAnswers : [];

      const exists = safeAnswers.find((ans) => ans.question_id === question_id);

      if (exists) {
        return safeAnswers.map((ans) =>
          ans.question_id === question_id
            ? { ...ans, answer_id: option.id }
            : ans
        );
      } else {
        return [...safeAnswers, { question_id, answer_id: option.id }];
      }
    });
  };

  const handleManagerChange = (value) => {
    setManager(value);
    localStorage.setItem("selectedManager", value);
  };

  useEffect(() => {
    if (isStudent) {
      setManager(managerList[0]?.manager_id)
    }
  }, [managerList])

  const handleOtpVerified = async () => {
    sessionStorage.setItem("otpVerified", "true");
    await getQuestions();
    setOtpVerified(true);

    // enterFullScreen();

    // document.addEventListener("fullscreenchange", enforceFullScreen);
  };

  const enterFullScreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const enforceFullScreen = () => {
    const isFullScreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
    if (!isFullScreen && !isExamSubmitted) {
      setExitCount((prev) => prev + 1);
      setIsFullscreenExited(true);
    } else {
      setIsFullscreenExited(false);
    }
  };

  const exitFullScreen = () => {
    const isFullScreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
    if (isFullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const handleReEnterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch((err) => console.log("Failed:", err));
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const scrollToQuestion = (e, index) => {
    e.preventDefault();
    questionRefs.current[index]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  // console.log("a",assessmentQuestions)
  const isQuestionAnswered = (id) => {
    return answers.some((ans) => ans.question_id === id);
  };
  const submitQuestions = async () => {
    setLoading(true);
    setShowConfirmationPopup(false);
    let enteredOtp = localStorage.getItem("verifiedOtp");
    const payload = [
      {
        assessment_id: assessmentId,
        company_id: companyId,
        candidate_id: candidateId,
        manager_id: manager,
        is_new_joiner: newJoiner == "True" ? true : false,
        is_existing_emp: newJoiner != "True" ? true : false,
        answers: answers,
        first_name: watch("firstName") ? watch("firstName") : "",
        last_name: watch("lastName") ? watch("lastName") : "",
        // otp: enteredOtp,
        job_title: watch("jobTitle"),
        tab_switch_count: tabSwitchCount,
        refresh_count: refreshCount,
        fullscreen_exist_count: exitCount,
        job_description: watch("jobDescription"),
        is_incomplete:
          answers.length !== assessmentQuestions.length ? true : false,
      },
    ];
    try {
      let response = await dispatch(submitAssessmentAnswers(payload)).unwrap();
      if (response.success == true) {
        setAnswers([]);
        setManager("");
        setIsExamSubmitted(true);
        setShowSubmitPopup(true);
        sessionStorage.removeItem("otpVerified");
        localStorage.removeItem("wasEverHere");
        localStorage.removeItem("refreshCount");
        setLoading(false);
        return;
        // exitFullScreen();
      } else {
        showNotification("Something went wrong", "error", 3000);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleSubmitForm = async (data) => {
    if (answers.length !== assessmentQuestions.length) {
      showNotification(
        "Please answer all the questions before submitting",
        "error",
        3000
      );
      return;
    }

    setShowConfirmationPopup(true);
  };

  const closeSubmitPopup = () => {
    setShowSubmitPopup(false);
    exitFullScreen();
    if (isStudent === "True") {
      navigate("/thank-you-individual");
    } else {
      navigate("/thank-you");
    }
  };

  // Rest of your existing useEffect hooks for security measures
  useEffect(() => {
    const blockedCombos = [
      "ctrl+c",
      "ctrl+v",
      "ctrl+x",
      "ctrl+s",
      "ctrl+p",
      "ctrl+shift+i",
      "ctrl+shift+j",
      "ctrl+shift+r",
      "ctrl+u",
      "ctrl+r",
      "meta+r",
      "f5",
      "f12",
      "ctrl+t",
    ];

    blockedCombos.forEach((combo) => {
      Mousetrap.bind(combo, (e) => {
        e.preventDefault();
        setShowWarning(true);
        return false;
      });
    });

    const handleKeyDown = (e) => {
      if (e.key === "Control" || e.key === "Alt") {
        e.preventDefault();
        setShowWarning(true);
      }
    };

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      setShowWarning(true);
      return "";
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      Mousetrap.reset();
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      setShowWarning(true);
    };

    window.addEventListener("contextmenu", handleContextMenu);
    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const storedAnswers = localStorage.getItem("assessmentAnswers");
    if (storedAnswers) {
      setAnswers(JSON.parse(storedAnswers));
    }
  }, []);

  const handleStartExam = async (e) => {
    e.preventDefault();
    const isValid = await trigger();
    if (!isValid) {
      showNotification("Please fill all required fields", "error", 3000);
      return;
    }
    try {
      const payload = {
        candidate_id: candidateId
      }
      const response = await dispatch(updateTestStatus(payload))
      setStartExam(true);
    } catch (error) {
      console.log("err", error)
    }

  };

  // useEffect(() => {
  //   const checkDevTools = () => {
  //     const threshold = 160;
  //     const widthThreshold = window.outerWidth - window.innerWidth > threshold;
  //     const heightThreshold =
  //       window.outerHeight - window.innerHeight > threshold;
  //     const orientationChanged = window.screen.orientation?.angle !== 0;

  //     const devtoolsOpen =
  //       widthThreshold || heightThreshold || orientationChanged;

  //     if (devtoolsOpen !== devToolsOpen) {
  //       setDevToolsOpen(devtoolsOpen);

  //       // Only set dev tools open state without clearing params
  //       if (devtoolsOpen) {
  //         setShowWarning(true); // Show your existing warning popup
  //       }
  //     }
  //   };

  //   const interval = setInterval(checkDevTools, 1000);
  //   return () => clearInterval(interval);
  // }, [devToolsOpen]);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     const isOtpVerified = localStorage.getItem("verifiedOtp") !== null;
  //     if (document.hidden && !isExamSubmitted && isOtpVerified) {
  //       setTabSwitchCount((prev) => prev + 1);
  //       setShowTabSwitchWarning(true);
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (exitCount >= 3) {
  //     setFullScreenLimitExceeded(true); // Show overlay
  //     setIsFullscreenExited(true); // Show overlay

  //     const countdownInterval = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(countdownInterval);

  //           // Exit fullscreen if not already exited
  //           if (document.fullscreenElement) {
  //             document.exitFullscreen?.();
  //           }

  //           // Clear OTP verified
  //           sessionStorage.removeItem("otpVerified");
  //           localStorage.removeItem("wasEverHere");
  //           localStorage.removeItem("refreshCount");
  //           localStorage.removeItem("verifiedOtp");

  //           // Navigate or auto-submit
  //           navigate("/test");

  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  // }, [exitCount]);

  // useEffect(() => {
  //   if (refreshCount >= 3) {
  //     setRefreshLimitExceeded(true); // Show overlay
  //     setShowRefreshWarning(true); // Show overlay

  //     const countdownInterval = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(countdownInterval);

  //           // Exit fullscreen if not already exited
  //           if (document.fullscreenElement) {
  //             document.exitFullscreen?.();
  //           }

  //           // Clear OTP verified
  //           sessionStorage.removeItem("otpVerified");
  //           localStorage.removeItem("wasEverHere");
  //           localStorage.removeItem("refreshCount");
  //           localStorage.removeItem("verifiedOtp");

  //           // Navigate or auto-submit
  //           navigate("/test");

  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  // }, [refreshCount]);

  // useEffect(() => {
  //   if (tabSwitchCount >= 3) {
  //     setLimitExceeded(true);
  //     setShowTabSwitchWarning(true);
  //     let counter = 3;

  //     const countdownInterval = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(countdownInterval);

  //           if (document.fullscreenElement) {
  //             document.exitFullscreen?.();
  //           }

  //           sessionStorage.removeItem("otpVerified");
  //           localStorage.removeItem("wasEverHere");
  //           localStorage.removeItem("refreshCount");
  //           localStorage.removeItem("verifiedOtp");
  //           navigate("/test");

  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  // }, [tabSwitchCount]);

  // useEffect(() => {
  //   // Get the existing count from localStorage
  //   const storedCount = parseInt(
  //     localStorage.getItem("refreshCount") || "0",
  //     10
  //   );
  //   const wasHere = localStorage.getItem("wasEverHere");
  //   if (wasHere && location.pathname == "/assessment/") {
  //     // Increment and update
  //     const newCount = storedCount + 1;
  //     localStorage.setItem("refreshCount", newCount.toString());

  //     // Set to state (optional, for display or logic)
  //     setRefreshCount(newCount);
  //     setShowRefreshWarning(true);
  //   } else {
  //     localStorage.setItem("wasEverHere", "true");
  //   }
  // }, [location]);

  return (
    <div className="min-h-screen bg-purple-50 p-4 font-sans">
      {/* {isMobileDevice ? (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-[999] flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
              <svg
                className="h-8 w-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Mobile Device Detected
            </h2>

            <p className="text-gray-600 mb-6">
              This assessment cannot be taken on mobile devices or small
              screens. Please use a desktop or laptop computer to continue.
            </p>

            <div className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded mb-6 text-left">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-purple-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-purple-700">
                    For security reasons and optimal experience, this assessment
                    requires a desktop browser with a minimum screen width of
                    768px.
                  </p>
                </div>
              </div>
            </div>

            <button
              onClick={() => (window.location.href = "/")} // Redirect to home or any other page
              className="w-full px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200"
            >
              Return to Home Page
            </button>
          </div>
        </div>
      ) : ( */}
      <>
        {/* {!otpVerified && (
          <OtpVerificationPopup onVerified={handleOtpVerified} />
        )} */}
        {loading && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
            <FiLoader className="animate-spin text-[#822bda] text-4xl" />
          </div>
        )}
        {!otpVerified && (
          <form onSubmit={handleSubmit(handleSubmitForm)}>
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-6">
              {/* Main Assessment Content */}
              <div className="flex-1">
                <div className="bg-white rounded-xl shadow-md p-6 mb-6">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 relative">
                    <h1 className="text-2xl font-bold text-purple-800 mb-4 md:mb-0">
                      Personality Assessment
                    </h1>
                    <div className="fixed top-4   md:w-56 right-4 z-50 flex items-center gap-3 bg-purple-50 px-4 py-2 rounded-lg shadow-lg">
                      <svg
                        className="w-5 h-5 text-purple-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      {startExam && (
                        <div className="">
                          <p className="text-sm text-gray-600 hidden md:block font-bold">
                            Time Remaining
                          </p>
                          <p className="md:font-medium text-purple-800">
                            <Timer
                              initialMinutes={45}
                              // initialSeconds={15}
                              onThreeMinuteWarning={() =>
                                setShowTimeWarning(true)
                              }
                            // onTimeUp={() => {
                            //   // Add event parameter if available
                            //   if (!testSubmitted) {
                            //     submitQuestions();
                            //   }
                            // }}
                            />
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="space-y-6">
                    {/* Name Section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-1">
                        <label
                          htmlFor="firstName"
                          className="block text-sm font-medium text-gray-700 text-left"
                        >
                          First Name<span className="text-[#f41033]"> *</span>
                        </label>
                        <input
                          id="firstName"
                          type="text"
                          className="w-full p-3 rounded-lg border border-purple-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                          placeholder="Enter first name"
                          {...register("firstName", {
                            required: "First name is required",
                            minLength: {
                              value: 2,
                              message:
                                "First name must be at least 2 characters",
                            },
                            pattern: {
                              value: /^[A-Za-z]+$/,
                              message: "First name can only contain letters",
                            },
                          })}
                          disabled={startExam}
                        />
                        {errors.firstName && (
                          <p className="text-red-500 text-xs">
                            {errors.firstName.message}
                          </p>
                        )}
                      </div>

                      <div className="space-y-1">
                        <label
                          htmlFor="lastName"
                          className="block text-sm font-medium text-gray-700 text-left"
                        >
                          Last Name<span className="text-[#f41033]"> *</span>
                        </label>
                        <input
                          id="lastName"
                          type="text"
                          className="w-full p-3 rounded-lg border border-purple-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                          placeholder="Enter last name"
                          {...register("lastName", {
                            required: "Last name is required",
                            minLength: {
                              value: 2,
                              message:
                                "Last name must be at least 2 characters",
                            },
                            pattern: {
                              value: /^[A-Za-z]+$/,
                              message: "Last name can only contain letters",
                            },
                          })}
                          disabled={startExam}
                        />
                        {errors.lastName && (
                          <p className="text-red-500 text-xs">
                            {errors.lastName.message}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Manager Section */}
                    {newJoiner == "False" && (
                      <>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {isStudent == "False" && <div className="space-y-1">
                            <label
                              htmlFor="manager"
                              className="block text-sm font-medium text-gray-700 text-left"
                            >
                              Select Reporting Manager
                              <span className="text-[#f41033]"> *</span>
                            </label>
                            <select
                              id="manager"
                              disabled={startExam}
                              defaultValue=""
                              // value={manager}
                              {...register("manager", {
                                required: "Please select manager",
                              })}
                              onChange={(e) =>
                                handleManagerChange(e.target.value)
                              }
                              className="w-full p-3 rounded-lg border border-purple-200 text-purple-800 focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                            >
                              <option value="">Select Reporting Manager</option>
                              {managerList.map((manager, i) => (
                                <option key={i} value={manager.manager_id}>
                                  {manager.full_name}
                                </option>
                              ))}
                            </select>
                            {errors.manager && (
                              <p className="text-red-500 text-xs">
                                {errors.manager.message}
                              </p>
                            )}
                          </div>}
                          <div className="space-y-1">
                            <label
                              htmlFor="jobTitle"
                              className="block text-sm font-medium text-gray-700 text-left"
                            >
                              Job Title
                              <span className="text-[#f41033]"> *</span>
                            </label>
                            <input
                              id="jobTitle"
                              type="text"
                              disabled={startExam}
                              className="w-full p-3 rounded-lg border border-purple-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                              placeholder="Enter job title"
                              {...register("jobTitle", {
                                required: "Job title is required",
                                minLength: {
                                  value: 2,
                                  message:
                                    "Job title must be at least 2 characters",
                                },
                                pattern: {
                                  value: /^[A-Za-z\s]+$/,
                                  message:
                                    "Job title can only contain letters and spaces",
                                },
                              })}
                            />
                            {errors.jobTitle && (
                              <p className="text-red-500 text-xs">
                                {errors.jobTitle.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-span-1 md:col-span-2 space-y-1">
                          <label
                            htmlFor="jobDescription"
                            className="block text-sm font-medium text-gray-700 text-left"
                          >
                            Job Description
                            <span> (minimum 20 words)</span> <span className="text-[#f41033]"> *</span>
                          </label>
                          <textarea
                            id="jobDescription"
                            rows="4"
                            placeholder="Enter your job description"
                            className="w-full p-3 rounded-lg border border-purple-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                            {...register("jobDescription", {
                              required: "Job description is required",
                              validate: (value) => {
                                const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
                                return wordCount >= 20 || "Job description must be at least 20 words";
                              }
                            })}
                            disabled={startExam}
                          />
                          {errors.jobDescription && (
                            <p className="text-red-500 text-xs">
                              {errors.jobDescription.message}
                            </p>
                          )}
                          <div className="w-full flex justify-end">
                            <span className="text-gray-500 text-xs">({watch("jobDescription")?.length > 0 ? watch("jobDescription")?.trim().split(" ").length : "0"} words)</span>
                          </div>
                        </div>
                      </>
                    )}
                    {!startExam && (
                      <button
                        onClick={(e) => handleStartExam(e)}
                        // type="submit"
                        className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-colors shadow-md hover:shadow-lg"
                      >
                        Start Assessment
                      </button>
                    )}
                  </div>
                </div>

                {startExam && (
                  <div className="bg-white rounded-lg shadow-sm p-6">
                    <div className="space-y-8">
                      {assessmentQuestions.map((q, idx) => (
                        <div
                          key={idx}
                          ref={questionRefs.current[idx]}
                          className="mb-8 scroll-mt-16"
                        >
                          <div className="flex items-start gap-3">
                            <div
                              className={`w-6 h-6 flex-shrink-0 rounded-full flex items-center justify-center text-xs font-medium mt-1
                        ${isQuestionAnswered(q._id)
                                  ? "bg-purple-100 text-purple-700 border border-purple-300"
                                  : "bg-gray-100 text-gray-600 border border-gray-200"
                                }`}
                            >
                              {idx + 1}
                            </div>
                            <div className="flex-1">
                              <p className="mb-3 font-medium text-gray-800 text-lg text-left">
                                {q.question_text}
                              </p>
                              <div className="space-y-3">
                                {q.options.map((opt, optIdx) => {
                                  const isSelected =
                                    answers.find((a) => a.question_id === q._id)
                                      ?.answer_id === opt.id;
                                  return (
                                    <button
                                      key={optIdx}
                                      onClick={(e) =>
                                        handleAnswerChange(e, idx, opt, q._id)
                                      }
                                      className={`w-full text-left p-3 rounded-lg border transition-all
                                  ${isSelected
                                          ? "border-purple-500 bg-purple-50 text-purple-700 ring-1 ring-purple-200"
                                          : "border-gray-200 hover:border-purple-300 hover:bg-purple-50 text-gray-700"
                                        }`}
                                    >
                                      {opt.text}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Mobile navigation */}
                    <div className="md:hidden mt-8 bg-purple-50 p-4 rounded-lg">
                      <h4 className="text-sm font-semibold text-purple-800 mb-3">
                        Question Navigation
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        {assessmentQuestions.map((question, index) => (
                          <button
                            key={index}
                            onClick={(e) => scrollToQuestion(e, index)}
                            className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium
                        ${isQuestionAnswered(question._id)
                                ? "bg-purple-100 text-purple-700 border border-purple-300"
                                : "bg-gray-100 text-gray-600 border border-gray-200"
                              } hover:bg-purple-200`}
                          >
                            {index + 1}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-200 ">
                      <div className="mb-2 text-sm text-gray-600">
                        <p className="text-left">
                          <strong>Tip:</strong> Gray indicates unanswered
                          questions, and purple indicates answered ones.
                        </p>
                        <p className="mt-2 text-left">
                          Please attempt all the questions before submitting the
                          assessment.
                        </p>
                      </div>

                      <div className="flex items-center mb-2">
                        <div className="w-4 h-4 rounded-full bg-purple-100 border border-purple-300 mr-2"></div>
                        <span className="text-sm text-gray-600">Answered</span>
                        <span className="text-sm text-gray-600 ml-1">
                          ({answers.length})
                        </span>
                      </div>
                      <div className="flex items-center">
                        <div className="w-4 h-4 rounded-full bg-gray-100 border border-gray-300 mr-2"></div>
                        <span className="text-sm text-gray-600">
                          Unanswered
                        </span>
                        <span className="text-sm text-gray-600 ml-1">
                          ({assessmentQuestions.length - answers.length})
                        </span>
                      </div>
                    </div>

                    <div className="mt-10 text-center md:hidden">
                      <button
                        // onClick={handleSubmitForm}
                        type="submit"
                        className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 px-8 rounded-lg text-lg transition-colors shadow-md hover:shadow-lg"
                      >
                        Submit Assessment
                      </button>
                    </div>

                    <div className="mt-8 bg-purple-50 border-l-4 border-purple-400 p-4 rounded">
                      <div className="flex items-start">
                        <div className="flex-shrink-0">
                          <svg
                            className="h-5 w-5 text-purple-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <p className="text-sm text-purple-800">
                            Please don't refresh the page or open new tabs
                            during the assessment.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Desktop Navigation Sidebar */}
              {startExam && (
                <div className="hidden md:block w-64 flex-shrink-0">
                  <div className="bg-white rounded-lg shadow-sm p-4 sticky top-4">
                    <h3 className="text-lg font-semibold text-purple-800 mb-4">
                      Questions
                    </h3>
                    <div className="grid grid-cols-5 gap-2">
                      {assessmentQuestions.map((question, index) => (
                        <button
                          key={index}
                          onClick={(e) => scrollToQuestion(e, index)}
                          className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors
                      ${isQuestionAnswered(question._id)
                              ? "bg-purple-100 text-purple-700 border border-purple-300"
                              : "bg-gray-100 text-gray-600 border border-gray-200"
                            } hover:bg-purple-200 hover:text-purple-800`}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-200 ">
                      <div className="mb-2 text-sm text-gray-600">
                        <p className="text-left">
                          <strong>Tip:</strong> Gray indicates unanswered
                          questions, and purple indicates answered ones.
                        </p>
                        <p className="mt-2 text-left">
                          Please attempt all the questions before submitting the
                          assessment.
                        </p>
                      </div>

                      <div className="flex items-center mb-2">
                        <div className="w-4 h-4 rounded-full bg-purple-100 border border-purple-300 mr-2"></div>
                        <span className="text-sm text-gray-600">Answered</span>
                        <span className="text-sm text-gray-600 ml-1">
                          ({answers.length})
                        </span>
                      </div>
                      <div className="flex items-center">
                        <div className="w-4 h-4 rounded-full bg-gray-100 border border-gray-300 mr-2"></div>
                        <span className="text-sm text-gray-600">
                          Unanswered
                        </span>
                        <span className="text-sm text-gray-600 ml-1">
                          ({assessmentQuestions.length - answers.length})
                        </span>
                      </div>
                    </div>

                    <div className="mt-6">
                      <button
                        // onClick={handleSubmitForm}
                        type="submit"
                        className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-colors shadow-md hover:shadow-lg"
                      >
                        Submit Assessment
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
        )}

        {/* All your existing popup modals */}
        {showWarning && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <svg
                  className="h-6 w-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-lg font-medium text-gray-900 mb-2">
                Restricted Action
              </h2>
              <p className="text-gray-500 mb-6">
                You attempted a restricted action during the assessment.
              </p>
              <button
                onClick={() => setShowWarning(false)}
                className="w-full px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                Continue Assessment
              </button>
            </div>
          </div>
        )}

        {showSubmitPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                <svg
                  className="h-6 w-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h2 className="text-lg font-medium text-gray-900 mb-2">
                Assessment Submitted
              </h2>
              <p className="text-gray-500 mb-6">
                Thank you for completing the assessment.
              </p>
              <button
                onClick={closeSubmitPopup}
                className="w-full px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                Close
              </button>
            </div>
          </div>
        )}

        {showTimeWarning && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-lg font-medium text-gray-900 mb-2">
                Time Warning
              </h2>
              <p className="text-gray-500 mb-6">
                Only 5 minutes remaining to complete your assessment!
              </p>
              <button
                onClick={() => setShowTimeWarning(false)}
                className="w-full px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {isFullscreenExited && !isExamSubmitted && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-50 flex flex-col items-center justify-center text-white">
            <h2 className="text-2xl font-bold mb-4">
              {fullScreenLimitExceeded
                ? "Fullscreen Limit Exceeded"
                : "Fullscreen Exited"}
            </h2>
            <p className="mb-4">
              {fullScreenLimitExceeded
                ? `You exited fullscreen too many times. Exiting in ${countdown}...`
                : "Please return to fullscreen to continue the assessment."}
            </p>
            {!fullScreenLimitExceeded && (
              <button
                onClick={handleReEnterFullscreen}
                className="bg-purple-600 hover:bg-purple-700 px-6 py-2 rounded-md"
              >
                Re-enter Fullscreen
              </button>
            )}
            {!fullScreenLimitExceeded && (
              <p className="mt-4 text-sm">Times exited: {exitCount}</p>
            )}
          </div>
        )}
        {showTabSwitchWarning && !isExamSubmitted && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-50 flex flex-col items-center justify-center text-white">
            <h2 className="text-2xl font-bold mb-4">Warning</h2>
            {!limitExceeded ? (
              <>
                <p className="mb-4">
                  You have switched tabs or minimized the window.
                </p>
                <p className="mb-4 text-lg font-semibold">
                  Tab switches detected: {tabSwitchCount}
                </p>
                <button
                  onClick={() => setShowTabSwitchWarning(false)}
                  className="bg-yellow-500 hover:bg-yellow-600 px-6 py-2 rounded-md"
                >
                  Continue Assessment
                </button>
              </>
            ) : (
              <>
                <p className="mb-4 font-semibold text-red-500 text-lg">
                  You have exceeded the allowed number of tab switches.
                </p>
                <p className="mb-4">
                  The assessment will be locked in{" "}
                  <span className="font-bold">{countdown}</span> second
                  {countdown > 1 ? "s" : ""}.
                </p>
              </>
            )}
          </div>
        )}
        {showRefreshWarning && !isExamSubmitted && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-50 flex flex-col items-center justify-center text-white">
            <h2 className="text-2xl font-bold mb-4">Warning</h2>
            {!refreshLimitExceeded ? (
              <>
                <p className="mb-4">
                  You have refreshed the page during the assessment.
                </p>
                <p className="mb-4 text-lg font-semibold">
                  Page refreshes detected: {refreshCount}
                </p>
                <button
                  onClick={() => setShowRefreshWarning(false)}
                  className="bg-blue-500 hover:bg-blue-600 px-6 py-2 rounded-md"
                >
                  Continue Assessment
                </button>
              </>
            ) : (
              <>
                <p className="mb-4 font-semibold text-red-500 text-lg">
                  You have exceeded the allowed number of page refreshes.
                </p>
                <p className="mb-4">
                  The assessment will be locked in{" "}
                  <span className="font-bold">{countdown}</span> second
                  {countdown > 1 ? "s" : ""}.
                </p>
              </>
            )}
          </div>
        )}
        {showConfirmationPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h2 className="text-lg font-medium text-gray-900 mb-2">
                Confirm Submission
              </h2>
              <p className="text-gray-500 mb-6">
                Are you sure you want to submit your assessment? You won't be
                able to make changes after submitting.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowConfirmationPopup(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  Cancel
                </button>
                <button
                  onClick={submitQuestions}
                  className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {devToolsOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[100] p-4 backdrop-blur-md">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 text-center relative">
              {/* Close button that won't actually work until dev tools are closed */}
              <button
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors cursor-not-allowed"
                disabled
                title="Close DevTools to continue"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                <svg
                  className="h-8 w-8 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>

              <h2 className="text-2xl font-bold text-red-600 mb-3">
                Developer Tools Detected
              </h2>

              <p className="text-gray-700 mb-4">
                You must close all developer tools to continue with the
                assessment.
              </p>

              <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded mb-6 text-left">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <button
                    onClick={() => {
                      if (!devToolsOpen) {
                        setDevToolsOpen(false);
                      }
                    }}
                    className={`mt-4 px-6 py-2 bg-purple-600 text-white rounded-lg ${devToolsOpen
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:bg-purple-700"
                      }`}
                    disabled={devToolsOpen}
                  >
                    {devToolsOpen
                      ? "Close DevTools to Continue"
                      : "Continue Assessment"}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-center space-x-2 text-gray-500">
                <svg
                  className="animate-spin h-5 w-5 text-purple-600"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Waiting for developer tools to close...</span>
              </div>
            </div>
          </div>
        )}
      </>
      {showAlreadySubmittedPopup && <ExamSubmittedPopup onClose={() => setShowAlreadySubmittedPopup(false)} />}
    </div>
  );
};

export default AssessmentTest;
